import React, { useCallback, useState } from 'react';
import { FiDownload } from 'react-icons/fi';

import { downloadDomNodeAsImage } from '../../../services/image-export';
import { useCurrentBoard } from '../../../services/state';
import Tooltip from '../../common/Tooltip';
import CircularProgress from '@mui/material/CircularProgress';

const ImageExportButton = () => {
  const { title } = useCurrentBoard();
  const [loading, setLoading] = useState(false);

  const exportBoardAsImage = useCallback(async () => {
    if (loading) return;

    setLoading(true);
    try {
      const treeNode = document.getElementById('tree');
      await downloadDomNodeAsImage(treeNode, `${title}.png`);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  }, [title, loading]);

  return (
    <Tooltip title={loading ? '' : 'Download board as image'}>
      <button className="action-btn" onClick={exportBoardAsImage}>
        {loading ? <CircularProgress color="white" size={22} /> : <FiDownload size={'1.5rem'} />}
      </button>
    </Tooltip>
  );
};

export default ImageExportButton;
